import _ from 'lodash'
import baseInputMetadata from './baseInputMetadata'

export default _.assign(
    {
        heightAuto: true
    },
    baseInputMetadata
)
